import React, { Component, useRef } from "react";
import classnames from "classnames";
import { FormattedMessage, injectIntl } from "react-intl";
import Truncate from "react-truncate";
import { useElementDimensions } from "@sportal/cdk/hooks";

import { Mobile, NotMobile } from "../../../hocs/Responsive";
import { ConfigLink } from "../../configLink/ConfigLink";

import "./PortalTitle.scss";

class PortalTitleContent extends Component {
  render() {
    const { className, link, intl, title } = this.props;

    return (
      <div className={classnames("portal-title", className)}>
        <ConfigLink
          to={link}
          aria-label={intl.formatMessage({ id: "aria_go_to_home" })}
        >
          <img
            className="portal-title__logo"
            src="logo_header.svg"
            alt="Portal Logo"
          />
        </ConfigLink>
        <div className="portal-title__name">
          <Mobile>
            <MobileTitle>
              {title || <FormattedMessage id="subscriber_portal_mobile" />}
            </MobileTitle>
          </Mobile>

          <NotMobile>
            <div className="portal-title__name--one-liner">
              {title || <FormattedMessage id="subscriber_portal_desktop" />}
            </div>
          </NotMobile>
        </div>
      </div>
    );
  }
}

const MobileTitle = ({ children }) => {
  const container = useRef(null);

  const { width } = useElementDimensions(container);

  return (
    <div ref={container} className="mobile-title">
      <Truncate lines={1} width={width - 20}>
        {children}
      </Truncate>
    </div>
  );
};

export const PortalTitle = injectIntl(PortalTitleContent);
